module.exports = __webpack_public_path__ + "static/img/youshi-info.304ab3ad.png";